module.exports = __webpack_public_path__ + "media/images/element/10-018add7da913974cbef5cea3c9f69e45.svg";